import { render, staticRenderFns } from "./8Quote.vue?vue&type=template&id=08952ee4"
import script from "./8Quote.vue?vue&type=script&lang=js"
export * from "./8Quote.vue?vue&type=script&lang=js"
import style0 from "./8Quote.vue?vue&type=style&index=0&id=08952ee4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports